
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7YEWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9dac8ccc4d1b894102a944d61ac4f665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cede6a65f901a4e$var$_react = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5cede6a65f901a4e$var$_baseNew = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5cede6a65f901a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cede6a65f901a4e$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $5cede6a65f901a4e$var$_react.default.createElement($5cede6a65f901a4e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5cede6a65f901a4e$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $5cede6a65f901a4e$var$_default = module.exports.default = $5cede6a65f901a4e$var$VideoPauseIcon;

});

parcelRegister("2XeTg", function(module, exports) {

$parcel$export(module.exports, "getCardDimensions", () => $ca7307657cf8aa32$export$90cc9ab68d35b5b9);
$parcel$export(module.exports, "CardWrapper", () => $ca7307657cf8aa32$export$6aa22a823032b784);
$parcel$export(module.exports, "CardOrientationWrapper", () => $ca7307657cf8aa32$export$11b226df951ea813);
/* CardOrientationWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $4JDbp = parcelRequire("4JDbp");

var $g3LxX = parcelRequire("g3LxX");

var $5un3P = parcelRequire("5un3P");

var $9wGTI = parcelRequire("9wGTI");
const $ca7307657cf8aa32$export$efa81a508b70a345 = {
    [(0, $5un3P.CardSizes).SMALL]: {
        minWidth: 228,
        maxWidth: 380,
        height: 72
    },
    [(0, $5un3P.CardSizes).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $5un3P.CardSizes).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $ca7307657cf8aa32$export$3bfbe20f0978c75 = {
    [(0, $5un3P.CardSizes).SMALL]: {
        minWidth: 240,
        maxWidth: 294,
        height: 84
    },
    [(0, $5un3P.CardSizes).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        height: 320
    },
    [(0, $5un3P.CardSizes).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        height: 320
    }
};
const $ca7307657cf8aa32$export$90cc9ab68d35b5b9 = (cardSize, isCardsVisualUpdateEnabled)=>{
    if (isCardsVisualUpdateEnabled && cardSize in $ca7307657cf8aa32$export$3bfbe20f0978c75) return $ca7307657cf8aa32$export$3bfbe20f0978c75[cardSize];
    return $ca7307657cf8aa32$export$efa81a508b70a345[cardSize];
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
const $ca7307657cf8aa32$export$6aa22a823032b784 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, cardMinWidth: cardMinWidth, cardMaxWidth: cardMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l03s5w": (0, $iAWao.default)(__cmplp.isFirstRowFull ? `${__cmplp.cardWidthOnFullRow}px` : `${__cmplp.cardMinWidth}px`),
            "--_1ufkv1r": (0, $iAWao.default)(__cmplp.isFirstRowFull ? `${__cmplp.cardWidthOnFullRow}px` : `${__cmplp.cardMaxWidth}px`)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1yt4v77o _kqswh2mm _1ul91c82 _p12fel4x",
            __cmplp.className
        ])
    });
});
const $ca7307657cf8aa32$export$11b226df951ea813 = ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, cardSize: cardSize, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, getItemDimensions: getItemDimensions })=>{
    const cardRef = (0, $gwFzn.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const cardDimensions = getItemDimensions ? getItemDimensions() : $ca7307657cf8aa32$export$90cc9ab68d35b5b9(cardSize || (0, $5un3P.CardSizes).MEDIUM, (0, $9wGTI.fg)('company_hub_cards_visual_update'));
    (0, $gwFzn.useEffect)(()=>{
        const scrollIntoViewBehavior = (0, $9wGTI.fg)('company_hub_carousel_v2') ? {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        } : {
            behavior: 'smooth',
            block: 'center'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior);
                // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            }
            // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ca7307657cf8aa32$export$6aa22a823032b784, {
        ref: cardRef,
        "data-testid": testId,
        isFirstRowFull: isFirstRowFull,
        cardWidthOnFullRow: cardWidthOnFullRow,
        cardMinWidth: cardDimensions.minWidth,
        cardMaxWidth: cardDimensions.maxWidth
    }, children, index === 0 && setWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4JDbp.WidthObserver), {
        setWidth: setWidth,
        offscreen: true
    }));
};

});

parcelRegister("4ZPO9", function(module, exports) {

$parcel$export(module.exports, "MIN_GAP_BETWEEN_CARDS", () => $f403cd2d1777febd$export$ba1fe8828f2c393e);
$parcel$export(module.exports, "MAX_GAP_BETWEEN_CARDS", () => $f403cd2d1777febd$export$f4a9066d04eb34fe);
$parcel$export(module.exports, "CardsOrientation", () => $f403cd2d1777febd$export$37f8d84bb48ae4b7);
/* CardsOrientation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEhUN = parcelRequire("eEhUN");

var $1qfLF = parcelRequire("1qfLF");

var $1Whri = parcelRequire("1Whri");

var $bPdpL = parcelRequire("bPdpL");

var $5tOl1 = parcelRequire("5tOl1");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $4JDbp = parcelRequire("4JDbp");

var $iJSpV = parcelRequire("iJSpV");

var $2XeTg = parcelRequire("2XeTg");

var $21iKg = parcelRequire("21iKg");
const $f403cd2d1777febd$var$i18n = (0, $2nPZH.defineMessages)({
    previous: {
        id: "custom-sites-extensions.link-cards.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "custom-sites-extensions.link-cards.row-orientation.next",
        defaultMessage: "Next"
    }
});
const $f403cd2d1777febd$export$ba1fe8828f2c393e = 16;
const $f403cd2d1777febd$export$f4a9066d04eb34fe = 16;
const $f403cd2d1777febd$var$styles = {
    flexBox: "_1e0c1txw _kqswh2mm _19bvze3t",
    stacked: "_1n261g80",
    row: "_1reo15vq _18m915vq",
    left: "_1bah1y6m",
    center: "_1bah1h6o",
    right: "_1bahesu3",
    iconBackgroundColor: "_2rko14q2 _bfhkvuon"
};
const $f403cd2d1777febd$export$37f8d84bb48ae4b7 = ({ numberOfCards: numberOfCards, cardsSize: cardsSize, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard })=>{
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $21iKg.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardsSize: cardsSize
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($eEhUN)))(setCurrentCardsGridWidth, 200);
    const orientation = isStacked ? 'grid' : 'row';
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $iJSpV.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: cards?.length,
        isRow: !isStacked
    });
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        testId: `link-cards-content-cards-${orientation}`,
        xcss: (0, $1Whri.cx)($f403cd2d1777febd$var$styles.flexBox, isStacked ? $f403cd2d1777febd$var$styles.stacked : $f403cd2d1777febd$var$styles.row, /**
     * Align left regardless of alignment if
     * - orientation is row
     * - the grid width is smaller or equal to the minimum width of the card size
     */ !isStacked || isGridSmallerOrEqualWidthToCards ? $f403cd2d1777febd$var$styles.left : $f403cd2d1777febd$var$styles[alignment]),
        style: {
            gap: `${spaceBetweenCards}px`
        }
    }, cards.map((card, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2XeTg.CardOrientationWrapper), {
            cardId: card.cardId,
            key: index,
            isFirstRowFull: isFirstRowFull,
            cardWidthOnFullRow: cardWidthOnFullRow,
            cardSize: cardsSize,
            setWidth: index === 0 ? setCurrentCardWidth : undefined,
            scrollToCard: index === scrollToIndex,
            clearScrollToCard: resetScrollIndex,
            testId: `link-cards-content-cards-${orientation}-card-${index}`,
            index: index,
            requestScrollIndex: requestScrollIndex,
            extensionLocalId: extensionLocalId
        }, renderCard(card))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4JDbp.WidthObserver), {
        setWidth: throttledSetWidth,
        offscreen: true
    })), !isStacked && !allCardsShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignInline: "end",
        testId: "link-cards-content-cards-row-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($f403cd2d1777febd$var$styles.iconBackgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
        isDisabled: isAtBeginning,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f403cd2d1777febd$var$i18n.previous),
        onClick: scrollToPrevious
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($f403cd2d1777febd$var$styles.iconBackgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
        isDisabled: isAtEnd,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f403cd2d1777febd$var$i18n.next),
        onClick: scrollToNext
    }))));
};

});
parcelRegister("iJSpV", function(module, exports) {

$parcel$export(module.exports, "useOrientationScrolling", () => $cd3ba1157b9213d4$export$3d5265f8773197d);

var $gwFzn = parcelRequire("gwFzn");
const $cd3ba1157b9213d4$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $gwFzn.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $gwFzn.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $gwFzn.useState)(-1);
    (0, $gwFzn.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $gwFzn.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $gwFzn.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};

});

parcelRegister("21iKg", function(module, exports) {

$parcel$export(module.exports, "useWidthAndSpacingCalculations", () => $0a5ab57a1f3ddcfd$export$a6443181a5681c94);

var $gwFzn = parcelRequire("gwFzn");

var $5un3P = parcelRequire("5un3P");

var $9wGTI = parcelRequire("9wGTI");

var $4ZPO9 = parcelRequire("4ZPO9");

var $2XeTg = parcelRequire("2XeTg");
const $0a5ab57a1f3ddcfd$var$MAX_NUMBER_OF_CARDS_PER_ROW = 6;
const $0a5ab57a1f3ddcfd$export$a6443181a5681c94 = ({ numberOfCards: numberOfCards, cardsSize: cardsSize, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $gwFzn.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $gwFzn.useState)(0);
    const cardDimensions = getItemDimensions ? getItemDimensions() : (0, $2XeTg.getCardDimensions)(cardsSize ?? (0, $5un3P.CardSizes).MEDIUM, (0, $9wGTI.fg)('company_hub_cards_visual_update'));
    /*
	 * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
	 * This means in situations that the width is rounded up, we have an edge case where we are
	 * making calculations with a grid width larger than what we actually have leading to layout issues.
	 *
	 * It is better to adjust the width we get from the observer down (-.5px) and
	 * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
	 */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS)) / (cardDimensions.minWidth + (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS)));
    const maxNumberOfCardsPerRow = (0, $9wGTI.fg)('company_hub_cards_visual_update') ? Math.min(numberOfCardsPerRow, $0a5ab57a1f3ddcfd$var$MAX_NUMBER_OF_CARDS_PER_ROW) : numberOfCardsPerRow;
    if (currentCardsGridWidthAdjustedForRounding <= cardDimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: cardDimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS),
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS) * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, cardDimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS);
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, (0, $4ZPO9.MAX_GAP_BETWEEN_CARDS) - (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS));
    const spaceBetweenCards = (0, $4ZPO9.MIN_GAP_BETWEEN_CARDS) + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};

});


parcelRegister("2Lc7n", function(module, exports) {

$parcel$export(module.exports, "useSmartCardFallbackUrl", () => $3cde7e684f675fa7$export$d571d5b2955da0d6);

var $6NezJ = parcelRequire("6NezJ");
const $3cde7e684f675fa7$export$1861ee29fc9bca35 = 'https://www.atlassian.com/';
const $3cde7e684f675fa7$export$d571d5b2955da0d6 = ()=>{
    const { currentDataRefHref: currentDataRefHref } = (0, $6NezJ.useConfluenceDependencies)();
    const baseUrl = window.location.origin;
    return currentDataRefHref ? `${baseUrl}${currentDataRefHref}` : $3cde7e684f675fa7$export$1861ee29fc9bca35;
};

});

parcelRegister("im49h", function(module, exports) {

$parcel$export(module.exports, "EmojiRenderer", () => $89b35c68973ec39a$export$56e4c85b6a8d02e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $6NezJ = parcelRequire("6NezJ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
const $89b35c68973ec39a$var$EmojiWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $iAWao.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o _p12f1efm",
            __cmplp.className
        ])
    });
});
function $89b35c68973ec39a$export$56e4c85b6a8d02e6({ emojiId: emojiId, context: context = 'linkCard', height: height = 40, width: width = 40 }) {
    const { lazyEmojiComponentLoader: LazyEmojiComponentLoader } = (0, $6NezJ.useConfluenceDependencies)();
    return !!emojiId ? /*#__PURE__*/ (0, $7UHDa.jsx)(LazyEmojiComponentLoader, {
        emoji: emojiId,
        height: height,
        wrapper: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($89b35c68973ec39a$var$EmojiWrapper, {
                ...props,
                width: width
            }),
        context: context,
        renderResourcedEmoji: true
    }) : null;
}

});

parcelRegister("5xb4G", function(module, exports) {

$parcel$export(module.exports, "useSmartCardEmoji", () => $9e2ac3240ff02a0e$export$6ed6867e3290476);

var $gwFzn = parcelRequire("gwFzn");

var $k00oi = parcelRequire("k00oi");

var $6NezJ = parcelRequire("6NezJ");
const $9e2ac3240ff02a0e$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $9e2ac3240ff02a0e$export$6ed6867e3290476 = (link)=>{
    const { submitError: submitError } = (0, $6NezJ.useConfluenceDependencies)();
    const [emojiId, setEmojiId] = (0, $gwFzn.useState)();
    const getEmoji = (0, $gwFzn.useCallback)(async ()=>{
        const client = new (0, $k00oi.default)();
        try {
            const queriedEmojiObject = await client.fetchData(link);
            setEmojiId($9e2ac3240ff02a0e$var$sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
        } catch (error) {
            submitError?.(error);
        }
    }, [
        link,
        submitError
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!!link) getEmoji();
    }, [
        link,
        getEmoji
    ]);
    return {
        emojiId: !!emojiId ? emojiId : null
    };
};

});

parcelRegister("aPwHF", function(module, exports) {

$parcel$export(module.exports, "useTrackedSmartCardState", () => $fbac79744aa5216e$export$9e87ed1f12141293);

var $gwFzn = parcelRequire("gwFzn");

var $6NezJ = parcelRequire("6NezJ");
const $fbac79744aa5216e$export$9e87ed1f12141293 = (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [errorCardStatus, setErrorCardStatus] = (0, $gwFzn.useState)('');
    const { submitError: submitError } = (0, $6NezJ.useConfluenceDependencies)();
    const shouldPreserveErrorStatus = (0, $gwFzn.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $gwFzn.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $gwFzn.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $gwFzn.useCallback)(({ status: status, err: err })=>{
        setErrorCardStatus(status);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err) failExperienceAndSendErrorMonitoring(err);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $gwFzn.useCallback)(()=>{
        onCardSucceeded(cardId);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};

});

parcelRegister("kBeeT", function(module, exports) {

$parcel$export(module.exports, "CommonErrorStateWrapper", () => $37a262c50ac49692$export$753ab1f7395823fe);
$parcel$export(module.exports, "ErrorStateContainer", () => $37a262c50ac49692$export$3c552bcab5076086);
$parcel$export(module.exports, "SmallErrorStateImage", () => $37a262c50ac49692$export$faeae5561971c7b4);
$parcel$export(module.exports, "SmallErrorStateTextWrapper", () => $37a262c50ac49692$export$19af98a8f5f18623);
$parcel$export(module.exports, "SmallErrorStateHeading", () => $37a262c50ac49692$export$9c344ac9a33cf3a1);
$parcel$export(module.exports, "ErrorStateSubheading", () => $37a262c50ac49692$export$12ace825a90a2141);
$parcel$export(module.exports, "ErrorStateSmallLink", () => $37a262c50ac49692$export$41901df1a2889134);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $gj7hi = parcelRequire("gj7hi");
const $37a262c50ac49692$export$753ab1f7395823fe = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNavigationThumbnail: isNavigationThumbnail, isHero: isHero, minWidth: minWidth, itemHeight: itemHeight, isSelected: isSelected, isInViewMode: isInViewMode, isVerticalHero: isVerticalHero, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $iAWao.default)(__cmplp.minWidth, "px"),
            "--_l2xmy5": (0, $iAWao.default)(__cmplp.itemHeight - 2, "px"),
            "--_50nsri": (0, $iAWao.default)(__cmplp.itemHeight, "px"),
            "--_102f1g9": (0, $iAWao.default)(__cmplp.isHero || __cmplp.isNavigationThumbnail ? 'none' : `0px 5px 12px 0px ${"var(--ds-border, #091E4224)"}`),
            "--_1hbwn6a": (0, $iAWao.default)(__cmplp.isHero ? 'cursor' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rkou2gc _1reo15vq _18m915vq _1e0c1txw _bfhk1j9a _19pkze3t _18u0ze3t",
            __cmplp.isNavigationThumbnail || __cmplp.isHero ? "_16qsglyw" : "_16qszucj",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.isHero || __cmplp.isNavigationThumbnail ? "_4t3i1ofn" : "_4t3i4sz5",
            __cmplp.isSelected ? "_19it110o" : __cmplp.isNavigationThumbnail || __cmplp.isHero ? "_19itt9nw" : "_19itglyw",
            __cmplp.isInViewMode && "_1dbz1x0d _d0al1n90",
            __cmplp.isHero && __cmplp.isVerticalHero ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $37a262c50ac49692$export$3c552bcab5076086 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $37a262c50ac49692$export$753ab1f7395823fe, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $37a262c50ac49692$export$faeae5561971c7b4 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $gj7hi.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_13li1v6z _mrkb1v6z _bfhk11bn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $37a262c50ac49692$export$19af98a8f5f18623 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1wpz1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $37a262c50ac49692$export$9c344ac9a33cf3a1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $37a262c50ac49692$export$12ace825a90a2141 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _syaz131l",
            __cmplp.size !== 'small' && "_1yt45gjp _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $37a262c50ac49692$export$41901df1a2889134 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syazp1wj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lIVWC", function(module, exports) {

$parcel$export(module.exports, "SmallErrorState", () => $379eeb186b27b9ed$export$6367f02d838ccaa1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kBeeT = parcelRequire("kBeeT");
const $379eeb186b27b9ed$export$6367f02d838ccaa1 = ({ itemId: itemId, image: image, heading: heading, subheading: subheading, itemHeight: itemHeight, link: link, isInViewMode: isInViewMode, hideLink: hideLink, isSelected: isSelected, isNavigationThumbnail: isNavigationThumbnail, minWidth: minWidth })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kBeeT.CommonErrorStateWrapper), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small-error-state",
        id: itemId,
        itemHeight: itemHeight,
        isInViewMode: isInViewMode,
        isSelected: isSelected,
        isNavigationThumbnail: isNavigationThumbnail,
        minWidth: minWidth,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kBeeT.SmallErrorStateImage), {
                src: image
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kBeeT.SmallErrorStateTextWrapper), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kBeeT.SmallErrorStateHeading), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...heading
                        })
                    }),
                    !!subheading && !hideLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kBeeT.ErrorStateSmallLink), {
                        href: link,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...subheading
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7lPqA", function(module, exports) {

$parcel$export(module.exports, "useItemsCombinedExperienceState", () => $18092cac9334e981$export$c6c5cac0793c45d9);

var $gwFzn = parcelRequire("gwFzn");
const $18092cac9334e981$export$c6c5cac0793c45d9 = (items)=>{
    const itemIdSet = (0, $gwFzn.useMemo)(()=>new Set(items.map((item)=>item.cardId)), [
        items
    ]);
    const [areAllItemsLoaded, setAreAllItemsLoaded] = (0, $gwFzn.useState)(false);
    const [itemFailureError, setItemFailureError] = (0, $gwFzn.useState)(null);
    const onItemFailed = (0, $gwFzn.useCallback)((error)=>{
        setItemFailureError(error);
    }, []);
    const onItemSucceeded = (0, $gwFzn.useCallback)((itemId)=>{
        itemIdSet.delete(itemId);
        if (itemIdSet.size === 0) setAreAllItemsLoaded(true);
    }, [
        itemIdSet
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            areAllItemsLoaded: areAllItemsLoaded,
            itemFailureError: itemFailureError,
            onItemSucceeded: onItemSucceeded,
            onItemFailed: onItemFailed
        }), [
        areAllItemsLoaded,
        itemFailureError,
        onItemSucceeded,
        onItemFailed
    ]);
};

});

parcelRegister("k34Sy", function(module, exports) {

$parcel$export(module.exports, "ItemSelectedToEditWrapper", () => $65c127aeef20460b$export$d3fc0aff4df25c77);
/* ItemSelectedToEditWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $g3LxX = parcelRequire("g3LxX");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $65c127aeef20460b$var$ItemSelectedToEditWrapperStyles = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp.isSelectedToEdit && "_1ivtugt7",
            __cmplp.isSelectedToRemove && "_1ivt1fcq",
            __cmplp.isSelectedToRemove && "_8ibab3bt _zbo0stnw _xu41idpf _1dqsidpf _pbjsidpf _139fidpf _1pm8kb7n _1b0d105o _1l6t1gly",
            __cmplp.className
        ])
    });
});
const $65c127aeef20460b$export$d3fc0aff4df25c77 = ({ extensionLocalId: extensionLocalId, itemId: itemId, children: children })=>{
    const itemRef = (0, $gwFzn.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const onItemClick = (0, $gwFzn.useCallback)(()=>{
        if (extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(itemId);
        }
    }, [
        itemId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($65c127aeef20460b$var$ItemSelectedToEditWrapperStyles, {
        ref: itemRef,
        isSelectedToEdit: isSelectedToEdit,
        isSelectedToRemove: isSelectedToRemove,
        onClick: onItemClick
    }, children);
};

});

parcelRegister("kHNfU", function(module, exports) {

$parcel$export(module.exports, "CustomImageUploadRenderer", () => $c37331190ee2a568$export$3f3413d4a48facf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2p7B1 = parcelRequire("2p7B1");

var $3rvSa = parcelRequire("3rvSa");

var $btHGY = parcelRequire("btHGY");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6NezJ = parcelRequire("6NezJ");

var $iUrRB = parcelRequire("iUrRB");
const $c37331190ee2a568$var$errorWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37331190ee2a568$var$ImageWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1osq _1bsb1osq _1h1tn7od _5ral1dfr",
            __cmplp.className
        ])
    });
});
const $c37331190ee2a568$var$uploadingImageStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
});
const $c37331190ee2a568$var$getImageMediaLocation = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $c37331190ee2a568$export$3f3413d4a48facf = ({ contentId: contentId, imageSrc: imageSrc = '', imageAltText: imageAltText, shouldShowErrorMessage: shouldShowErrorMessage = false })=>{
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent, createRendererMediaProvider: createRendererMediaProvider } = (0, $6NezJ.useConfluenceDependencies)();
    const intl = (0, $dBxQj.default)();
    const [collectionId, imageId] = $c37331190ee2a568$var$getImageMediaLocation(contentId, imageSrc);
    const mediaConfig = $c37331190ee2a568$var$useMediaConfig({
        collectionId: collectionId,
        createRendererMediaProvider: createRendererMediaProvider
    });
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    if (!mediaConfig || !mediaConfig.authProvider) return null;
    const errorState = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $c37331190ee2a568$var$errorWrapperStyles,
        testId: "custom-image-upload-error",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
                label: intl.formatMessage((0, $iUrRB.messages).warningIcon),
                color: "var(--ds-icon-subtle, #626F86)"
            }),
            shouldShowErrorMessage && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $iUrRB.messages).imageFailedMessage
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3rvSa.MediaClientProvider), {
        clientConfig: mediaConfig,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $btHGY.MediaImageWithErrorBoundary), {
            identifier: {
                mediaItemType: 'file',
                id: imageId,
                collectionName: mediaConfig?.collection
            },
            mediaClientConfig: {
                authProvider: mediaConfig.authProvider
            },
            apiConfig: {
                allowAnimated: true,
                mode: 'fit',
                upscale: false
            },
            children: ({ data: data, loading: loading, error: error })=>{
                if (loading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    testId: "custom-image-upload-loading",
                    xcss: $c37331190ee2a568$var$uploadingImageStyles
                });
                if (error || !data?.src) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        errorState,
                        /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceError, {
                            error: new Error('Image failed to load in CustomImageUploadRenderer')
                        })
                    ]
                });
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($c37331190ee2a568$var$ImageWrapper, {
                            src: data.src,
                            alt: imageAltText,
                            "data-testid": "custom-image-upload"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceSuccess, {})
                    ]
                });
            }
        }, imageId)
    });
};
function $c37331190ee2a568$var$useMediaConfig({ collectionId: collectionId, createRendererMediaProvider: createRendererMediaProvider }) {
    const [mediaConfig, setMediaConfig] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        async function createMediaConfig() {
            if (!createRendererMediaProvider) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await createRendererMediaProvider({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        createRendererMediaProvider
    ]);
    return mediaConfig;
}

});
parcelRegister("iUrRB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08582f179b34db1b$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $08582f179b34db1b$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    imageFailedMessage: {
        id: "custom-sites-extensions.link-cards.image-failed-to-load",
        defaultMessage: "Image failed to load"
    },
    warningIcon: {
        id: "custom-sites-extensions.link-cards.warning",
        defaultMessage: "Warning icon for image failed to load"
    }
});

});


parcelRegister("jqjsu", function(module, exports) {

$parcel$export(module.exports, "getImageTypeToShow", () => $04a364cca99a3e77$export$25f23b916a7baf7);

var $3U9FW = parcelRequire("3U9FW");
const $04a364cca99a3e77$export$25f23b916a7baf7 = ({ imageSrc: imageSrc })=>{
    const showUnsplashImage = (0, $3U9FW.isUnsplashImage)(imageSrc);
    const showExternalSiteImage = !!imageSrc && $04a364cca99a3e77$var$externalSiteMatcher.test(imageSrc);
    const showCustomUploadedImage = !!imageSrc && !(0, $3U9FW.isUnsplashImage)(imageSrc) && !showExternalSiteImage;
    return {
        showUnsplashImage: showUnsplashImage,
        showExternalSiteImage: showExternalSiteImage,
        showCustomUploadedImage: showCustomUploadedImage,
        hasImage: showUnsplashImage || showCustomUploadedImage
    };
};
const $04a364cca99a3e77$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

});
parcelRegister("3U9FW", function(module, exports) {

$parcel$export(module.exports, "isUnsplashImage", () => $1ca50115dc18590e$export$fc883aabd3b0aeb1);

var $5SBbH = parcelRequire("5SBbH");
const $1ca50115dc18590e$export$fc883aabd3b0aeb1 = (imageUrl)=>{
    if (!imageUrl) return false;
    return imageUrl?.includes((0, $5SBbH.UNSPLASH_URL));
};

});
parcelRegister("5SBbH", function(module, exports) {

$parcel$export(module.exports, "UNSPLASH_URL", () => $61d136b6348f1c29$export$fe42ffbf1f8cac0e);
const $61d136b6348f1c29$export$fe42ffbf1f8cac0e = 'images.unsplash.com';

});




//# sourceMappingURL=LinkCards.44801c8c.js.map
